import { render, staticRenderFns } from "./FormPhoneType.vue?vue&type=template&id=9b4a9024"
import script from "./FormPhoneType.vue?vue&type=script&lang=js"
export * from "./FormPhoneType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports